import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DCF, TDcfSliceState, TVesselDcf, TSummaryDcf, TDcfValue } from './dcfTypes';

const initialState: TDcfSliceState = {
    vesselListDcf: {
        dataList: null,
        loading: false,
        loadingError: null,
    },
    summaryDcf: {
        dataList: null,
        infoNote: '',
        loading: false,
        loadingError: null,
    },
    dcfValueState: {
        dcfValueData: null,
        loadingError: null,
        loading: false
    }
};

const dcfSlice = createSlice({
    name: DCF,
    initialState,
    reducers: {
        getDcfValueRequestAction: (state: TDcfSliceState, _: PayloadAction<number[] | undefined>) => {
            if (state.dcfValueState) {
                state.dcfValueState.loadingError = null;
                state.dcfValueState.loading = true;
            }
        },
        getDcfValueSuccessAction: (
            state: TDcfSliceState,
            { payload: data }: PayloadAction<TDcfValue>,
        ) => {
            if (state.dcfValueState) {
                state.dcfValueState.dcfValueData = data;
                state.dcfValueState.loadingError = null;
                state.dcfValueState.loading = false;
            }
        },
        getDcfValueErrorAction: (
            state: TDcfSliceState,
            { payload: error }: PayloadAction<any>,
        ) => {
            if (state.dcfValueState) {
                state.dcfValueState.loadingError = {
                    message: (error.response && error.response.data) || error.message || '',
                    name: error.name,
                    stack: error.stack,
                };
                state.dcfValueState.loading = false;
            }
        },
        resetDcfValueAction: (state: TDcfSliceState) => {
            if (state.dcfValueState) {
                state.dcfValueState.dcfValueData = null;
                state.dcfValueState.loadingError = null;
                state.dcfValueState.loading = true;
            }
        },

        getVesselDcfRequestAction: (state: TDcfSliceState, _: PayloadAction<number[] | undefined>) => {
            if (state.vesselListDcf) {
                state.vesselListDcf.loadingError = null;
                state.vesselListDcf.loading = true;
            }
        },
        getVesselDcfSuccessAction: (
            state: TDcfSliceState,
            { payload: data }: PayloadAction<TVesselDcf[]>,
        ) => {
            if (state.vesselListDcf) {
                state.vesselListDcf.dataList = data;
                state.vesselListDcf.loading = false;
                state.vesselListDcf.loadingError = null;
            }
        },
        getVesselDcfErrorAction: (
            state: TDcfSliceState,
            { payload: error }: PayloadAction<any>,
        ) => {
            if (state.vesselListDcf) {
                state.vesselListDcf.loading = false;
                state.vesselListDcf.loadingError = {
                    message: (error.response && error.response.data) || error.message || '',
                    name: error.name,
                    stack: error.stack,
                };
            }
        },
        getSummaryDcfRequestAction: (state: TDcfSliceState, _: PayloadAction<number[] | undefined>) => {
            if (state.summaryDcf) {
                state.summaryDcf.loading = true;
                state.summaryDcf.loadingError = null;
            }
        },
        getSummaryDcfSuccessAction: (
            state: TDcfSliceState,
            { payload: data }: PayloadAction<TSummaryDcf>,
        ) => {
            if (state.summaryDcf) {
                state.summaryDcf.dataList = data.dataList;
                state.summaryDcf.infoNote = data.infoNote;
                state.summaryDcf.loading = false;
                state.summaryDcf.loadingError = null;
            }
        },
        getSummaryDcfErrorAction: (
            state: TDcfSliceState,
            { payload: error }: PayloadAction<any>,
        ) => {
            if (state.summaryDcf) {
                state.summaryDcf.loading = false;
                state.summaryDcf.loadingError = {
                    message: (error.response && error.response.data) || error.message || '',
                    name: error.name,
                    stack: error.stack,
                };
            }
        },
    },
});

export const { getDcfValueRequestAction, getDcfValueSuccessAction, getDcfValueErrorAction, resetDcfValueAction,
    getVesselDcfRequestAction, getVesselDcfSuccessAction, getVesselDcfErrorAction,
    getSummaryDcfRequestAction, getSummaryDcfSuccessAction, getSummaryDcfErrorAction
} =
    dcfSlice.actions;
export default dcfSlice.reducer;